import Vue from 'vue'
var truncate = require('vue-truncate-filter')
Vue.use(truncate)